export function today(): string {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();

  return `${year}-${month
    .toString()
    .padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
}
